import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useState, useEffect, useMemo } from 'react';
import MonitorWSService from '../../services/monitorwsservice';
import WidgetSettings from "./widgetSettings"
import { selectionTypes } from "../utils/consts";
import WidgetTools from "./widgetTools";
import { removeWidget } from "../../redux/supervisorSlice";
import DataGrid, { Column, MasterDetail } from 'devextreme-react/data-grid';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from "devextreme/data/array_store";
import ActiveAgentsChats from './activeagentschats';

const GridRenderer = React.memo(({ dataSource, rtl }) => {
    const { t } = useTranslation();
    return (
        <DataGrid id="activechats"
            dataSource={dataSource}
            showBorders={false}
            columnAutoWidth={true}
            width={"100%"}
            height={"99%"}
            allowColumnResizing={true}
            repaintChangesOnly={true}
            loadPanel={{ enabled: false }}
            rtlEnabled={rtl}>
            <Column dataField="groupId" visible={false} />
            <Column dataField="agents" visible={false} />
            <Column dataField="groupName" />
            <Column dataField="activeChats" width={170} caption={t("activechats")} />
            <Column dataField="postponedChats" width={170} caption={t("postponed")} />
            <Column dataField="total" width={170} caption={t("total")} />
            <MasterDetail enabled={true} component={ActiveAgentsChats} />
        </DataGrid>);
});

function ActiveChats(props) {

    const dataSource = useMemo(() => new DataSource({
        store: new ArrayStore({
            key: "groupId",
            data: []
        }),
        reshapeOnPush: true
    }), []);

    const { t } = useTranslation();
    const [showSettings, setShowSettings] = useState(false);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [channel, setChannel] = useState(localStorage.getItem(`ActiveChats_channel_${props.identifier}_user${props.id}`) || "");
    const [channelName, setChannelName] = useState(localStorage.getItem(`ActiveChats_channelName_${props.identifier}_user${props.id}`) || "");

    useEffect(() => {
        return () => {
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/activechats", {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe("activechats");
            }
        };
    }, []);

    useEffect(() => {

        if (props.connected) {
            let selectedGroups = JSON.parse(localStorage.getItem(`ActiveChats_groups_${props.identifier}_user${props.id}`) || "[]");
            let channel = localStorage.getItem(`ActiveChats_channel_${props.identifier}_user${props.id}`) || "";
            setSelectedGroups(selectedGroups);

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/activechats/`, function (callsbygroup) {
                if (!document.hidden) {
                    let data = JSON.parse(callsbygroup.body);


                    let groupIds = dataSource.items().map(x => x.groupId);

                    groupIds.forEach(x => {
                        if (data.map(c => c.groupId).indexOf(x) === -1) {
                            dataSource.store().push([{ type: 'remove', key: x }]);
                        }
                    });

                    data.forEach(v => {
                        if (groupIds.indexOf(v.groupId) > -1) {
                            dataSource.store().push([{ type: 'update', key: v.groupId, data: v }]);
                        } else {
                            dataSource.store().push([{ type: 'insert', data: v }]);
                        }
                    });
                }
            }, { id: "activechats" });

            MonitorWSService.stompClient.send("/app/subscribe/activechats", {}, JSON.stringify({
                token: props.token,
                groupsIds: selectedGroups,
                channel: channel
            }));

        }

    }, [props.connected]);

    const setGroupsAndChannel = (groups, channel, channelName) => {
        setShowSettings(!showSettings);
        setSelectedGroups(groups);
        localStorage.setItem(`ActiveChats_groups_${props.identifier}_user${props.id}`, JSON.stringify(groups));

        setChannel(channel);
        setChannelName(channelName);
        localStorage.setItem(`ActiveChats_channel_${props.identifier}_user${props.id}`, channel);
        localStorage.setItem(`ActiveChats_channelName_${props.identifier}_user${props.id}`, channelName);

        MonitorWSService.stompClient.send("/app/subscribe/activechats", {}, JSON.stringify({
            token: props.token,
            groupsIds: groups,
            channel: channel
        }));

    };

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    }

    return (<div className="card card-flush overflow-hidden h-lg-20 widget-container">
        <div className="card-header">
            <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("wave-pulse")} /> {t("activechats")}</span>
            </h3>
            <div className="card-toolbar" style={{ zIndex: 9999 }}>
                <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
            </div>
        </div>
        <div className="card-body" style={{ "padding": "0px", height: "80%" }}>
            <GridRenderer dataSource={dataSource} rtl={props.rtl} />
        </div>
        <WidgetSettings key={`settings_${props.identifier}`} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroupsAndChannel={setGroupsAndChannel} groups={selectedGroups} selectionType={selectionTypes.MESSAGESQUEUE} channel={channel} channelName={channelName}></WidgetSettings>
    </div>);
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id,
        rtl: state.parameters.rtl,
    };
};

export default connect(mapStateToProps, { removeWidget })(ActiveChats);